<template>
  <div class="popup-timer-ended">
    <div class="left">
      <UIButton
        :ghost="true"
        icon="clock"
        v-if="lessThanFiveMinutesOld && !isOrganizationEducation"
        class="paidextension"
        @click="$emit('openPaidExtension')"
      >{{ $t('Paid Extension') }}</UIButton>
      <UIButton
        :ghost="true"
        class="editstation"
        @click="$emit('editBooking')"
      >{{ $t("Edit Reservation") }}</UIButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import UIButton from '@/core/shared/components/ui/UIButton';

@Component({
  components: {
    UIButton,
  },
  props: {
    endTime: {
      type: String,
      required: true,
    },
    isOrganizationEducation: {
      type: Boolean,
      default: false,
    },
  },
})
export default class BookingDetailEnded extends Vue {
  get currentTime () { return this.$store.getters.currentTime; }
  get lessThanFiveMinutesOld () {
    const diff = moment(this.currentTime).diff(moment(this.endTime), 'minutes');
    return diff <= 5 && diff >= 0;
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.popup-timer-ended {
  @media (--desktop) {
    display: flex;
    align-items: flex-start;
    padding: 0;
  }

  & .left {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    padding: var(--spacingSm) 0 0 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .paidextension {
      flex: 1 1 auto;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: var(--spacingSm);

      & svg {
        fill: var(--colorGeyser);
        width: 1.6rem;
        height: 1.6rem;
        margin-right: var(--spacingSm);
      }
    }

    & .editstation {
      flex: 1 1 auto;
      width: auto;
    }
  }
}
</style>
